/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default async function access(initialState?: { roles?:any[], currentUser?: API.CurrentUser , permissions?: any[], fetchUserInfo?: () => Promise<API.CurrentUser | undefined>, MenuInfo?: any[]} | undefined) {
  let permissions:any = {}
  if (initialState?.permissions) {
    permissions = initialState?.permissions
  }
  return {
    canReadButton: (routeName: string) => {
      if (permissions[0] && permissions[0] === '*:*:*') {
        return true
      }
      return permissions.includes(routeName)
    }
  };
}
